import { render } from "./TableBookingComponent.vue?vue&type=template&id=1a60ed71&scoped=true"
import script from "./TableBookingComponent.vue?vue&type=script&lang=js"
export * from "./TableBookingComponent.vue?vue&type=script&lang=js"

import "./TableBookingComponent.vue?vue&type=style&index=0&id=1a60ed71&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a60ed71"]])

export default __exports__